import React from 'react';
import { Helmet } from 'react-helmet';

export const MicroDataHelmet = ({ schemaOrgJSONLD }) => (
  <Helmet>
    <script type='application/ld+json'>
      {JSON.stringify(schemaOrgJSONLD)}
    </script>
  </Helmet>
);
